import { getSafe, pushSafe } from "../../../util/storeHelper";
import generateSubtitle from "./generateSubtitle";
function searchChildren(t, categories, rootId, mods) {
    const children = Object.keys(categories)
        .filter((id) => rootId === categories[id].parentCategory)
        .sort((lhs, rhs) => categories[lhs].order - categories[rhs].order);
    const childrenList = [];
    children.forEach((childId) => {
        const nestedChildren = searchChildren(t, categories, childId, mods);
        // tslint:disable-next-line:no-shadowed-variable
        const nestedModCount = nestedChildren.reduce((total, child) => total + child.modCount, 0);
        const modCount = getSafe(mods, [childId], []).length;
        const subt = mods !== undefined
            ? generateSubtitle(t, childId, mods, nestedModCount)
            : "";
        const child = {
            categoryId: childId,
            title: categories[childId].name,
            subtitle: subt,
            expanded: false,
            modCount,
            parentId: categories[childId].parentCategory,
            order: categories[childId].order,
            children: nestedChildren,
        };
        childrenList.push(child);
    });
    return childrenList;
}
/**
 * create the treeDataObject from the categories inside the store
 *
 * @param {Object} categories
 * @param {any} mods
 * @return {[]} categoryList
 *
 */
function createTreeDataObject(t, categories, mods, customSort) {
    const categoryList = [];
    const modsByCategory = Object.keys(mods || {}).reduce((prev, current) => {
        const category = getSafe(mods, [current, "attributes", "category"], undefined);
        if (category === undefined) {
            return prev;
        }
        return pushSafe(prev, [category], current);
    }, {});
    const sortFunc = (lhs, rhs) => customSort !== undefined
        ? customSort(lhs, rhs)
        : categories[lhs].order - categories[rhs].order;
    const roots = Object.keys(categories)
        .filter((id) => categories[id].parentCategory === undefined)
        .sort((lhs, rhs) => sortFunc(lhs, rhs));
    roots.forEach((rootElement) => {
        let childCategoryModCount = 0;
        const children = Object.keys(categories)
            .filter((id) => rootElement === categories[id].parentCategory)
            .sort((lhs, rhs) => sortFunc(lhs, rhs));
        const childrenList = [];
        children.forEach((element) => {
            const nestedChildren = searchChildren(t, categories, element, modsByCategory);
            // tslint:disable-next-line:no-shadowed-variable
            const nestedModCount = nestedChildren.reduce((total, child) => total + child.modCount, 0);
            const subtitle = generateSubtitle(t, element, modsByCategory, nestedModCount);
            const modCount = getSafe(modsByCategory, [element], []).length;
            childCategoryModCount += modCount;
            const child = {
                categoryId: element,
                title: categories[element].name,
                subtitle,
                expanded: false,
                modCount,
                parentId: categories[element].parentCategory,
                order: categories[element].order,
                children: nestedChildren,
            };
            childrenList.push(child);
        });
        categoryList.push({
            categoryId: rootElement,
            title: categories[rootElement].name,
            subtitle: generateSubtitle(t, rootElement, modsByCategory, childCategoryModCount),
            expanded: false,
            parentId: undefined,
            modCount: getSafe(modsByCategory, [rootElement], []).length,
            children: childrenList,
            order: categories[rootElement].order,
        });
    });
    return categoryList;
}
export default createTreeDataObject;
